// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"0cee7aa7","236":"91fa0097","346":"60b6a038","453":"0f711788","466":"f841de2f","501":"c81436a4","561":"2cc9e4a9","675":"fb07e092","729":"867d3f3e","886":"a6ba118d"}[chunkId] + ".chunk.js";
};